import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformUserDreamGoalPeriod from '@/types/table/platformUserDreamGoalPeriod';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformUserDreamGoalPeriodData extends PlatformUserDreamGoalPeriod {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformUserDreamGoalPeriodController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformUserDreamGoalPeriodData>>(API_CONTEXT + '/app/platformUserDreamGoalPeriod/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformUserDreamGoalPeriodData>(API_CONTEXT + '/app/platformUserDreamGoalPeriod/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformUserDreamGoalPeriod/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformUserDreamGoalPeriod/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformUserDreamGoalPeriod/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserDreamGoalPeriod/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserDreamGoalPeriod/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserDreamGoalPeriod/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformUserDreamGoalPeriod/deleteBatch', params, httpOptions);
  }
}
